module.exports = __webpack_public_path__ + "img/tiyanqrcode.1d6f9393.png";